module.exports = __webpack_public_path__ + "static/img/2.17334590.jpg";